import {
  RecruiterSidebarItemState,
  SidebarItemStateHandlerParams,
} from '@features/oneOnboardingAdmin/pages/NewCandidateProfilePage/CustomCandidateProfileSidebar/handlerClasses/types';

export const useCandidateInfo = ({
  setPageStepContext,
  flowWrapper,
  steps,
}: SidebarItemStateHandlerParams): RecruiterSidebarItemState => {
  const { page } = flowWrapper.getCurrentStepAndPage();

  const active = page === 'PERSONAL_INFO';
  const completed = flowWrapper.isPageCompleted('CANDIDATE_DETAILS', 'PERSONAL_INFO');

  const disabled = !(active || completed);

  return {
    active,
    disabled,
    completed,
    onClick: () => {
      const step = steps.find((x) => x.name === 'PERSONAL_INFO');
      setPageStepContext({ step, page: undefined });
    },
  };
};
